export default __webpack_public_path__ + "static/media/psu-stidti-lightitalic.2b8e8d10.ttf";